import { render, staticRenderFns } from "./DataRecords.vue?vue&type=template&id=c3682ab8&scoped=true&"
import script from "./DataRecords.vue?vue&type=script&lang=js&"
export * from "./DataRecords.vue?vue&type=script&lang=js&"
import style0 from "./DataRecords.vue?vue&type=style&index=0&id=c3682ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3682ab8",
  null
  
)

export default component.exports